import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import UserLoader from '../components/common/Squeleton';
import { allService } from '../services';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';
import NewTransaction from '../components/users/newtransaction';
import { Link, useHistory, useParams } from 'react-router-dom';
import { logOut, removeToken, deleteuser } from '../actions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWrapper } from '../fetchWrapper';
import $ from 'jquery';

export default function Users() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { token } = useParams();

  const user = useSelector((state) => state.user);
  const isAuthenticated = useSelector((state) => state.connection);

  const [showNewTransaction, setShowNewTransaction] = useState(false);

  const [downloadPopup, showDownloadPopup] = useState(false);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentLink, setPaymentLink] = useState(null);

  const [paymentMethod, setPaymentMethod] = useState({
    id: '',
    logo: '',
    code: '',
    name: '',
    reg_exp: '',
  });

  const [transacData, settransacData] = useState({
    type: 'TOPUP',
    amount: '',
    method: '',
    phone: '',
    name: '',
  });

  const [error, setError] = useState({
    amountErr: '',
    phoneErr: '',
    transacErr: '',
  });
  const [isDisable, setDisable] = useState(true);
  const [transacSuccessMsg, displayTransacSuccessMsg] = useState(false);

  const [lang, setLang] = useState('Fr');
  const [userLoader, displayUserLoader] = useState(true);
  const [pageErr, displayPageErr] = useState(false);

  // function use to naviagte a user
  const navigation = (nav) => {
    history.push({
      pathname: nav,
    });
  };

  //Function to use to handle language choice
  const changeLanguageHandler = (l) => {
    i18n.changeLanguage(l.toLowerCase());
    setLang(l);
  };

  const handleChangepayerPhone = (e) =>
    settransacData({ ...transacData, phone: e.target.value });

  const handleChangeTransacAmount = (e) =>
    settransacData({ ...transacData, amount: e.target.value });

  const handleChangePayerName = (e) =>
    settransacData({ ...transacData, name: e.target.value });

  const handleSelectPaymentMethod = (paymentMethod) => {
    setPaymentMethod(paymentMethod);
    settransacData({ ...transacData, method: paymentMethod.id });
  };

  const saveTransacData = () => {
    const data = {
      payer_name: transacData.name,
      payer_number: transacData.phone,
      payment_processor: transacData.method,
      amount: transacData.amount,
      type: transacData.type,
      link: token,
    };

    setError({ ...error, transacErr: '' });

    setShowNewTransaction(true);

    allService
      .paymentLinkInit(data)
      .then((d) => {
        setShowNewTransaction(false);

        // if (isAuthenticated) {
        //   toast.success(t('Operation_successfuly_completed'), {
        //     style: {
        //       padding: '16px',
        //       color: '#fff',
        //       background: '#02274a',
        //       borderRadius: '10px',
        //     },
        //     iconTheme: {
        //       primary: '#229954',
        //       secondary: '#FFFAEE',
        //     },
        //   });
        // } else {
        if (d.success === true) {
          displayTransacSuccessMsg(true);
        } else {
          setError({ ...error, transacErr: t('A_server_error_payment') });
        }
        // }
      })
      .catch((e) => {
        setShowNewTransaction(false);
        setError({ ...error, transacErr: t('A_server_error') });
      });
  };

  const avortTransac = () => {
    fetchWrapper.abortTransac();
    setShowNewTransaction(false);
  };

  const disconnect = () => {
    dispatch(logOut());
    dispatch(removeToken());
    dispatch(deleteuser());
    history.push('/login');
  };

  // functions to perform side effects
  useEffect(() => {
    displayUserLoader(true);

    Promise.all([
      allService.getAllWithoutToken('payment-processors/list'),
      allService.getPaymentLink(token),
    ])
      .then(([paymentMethods, paymentLinkData]) => {
        const payLink = paymentLinkData.data.payment_link;

        setPaymentMethods(paymentMethods);
        setPaymentLink(payLink);

        if ((paymentMethods || []).length > 0) {
          setPaymentMethod(paymentMethods[0]);
          settransacData({
            ...transacData,
            method: paymentMethods[0].code,
            amount: payLink.amount,
          });
        }
      })
      .catch((e) => displayPageErr(true))
      .finally((_) => displayUserLoader(false));
  }, []);

  useEffect(() => {
    setDisable(
      allService.empty(transacData.type) ||
        allService.empty(transacData.amount) ||
        allService.empty(transacData.phone) ||
        allService.empty(transacData.method) ||
        !allService.validateOperatorRegExp(
          paymentMethod ? paymentMethod.reg_exp : '',
          transacData.phone,
        ),
    );

    setError({
      ...Error,
      phoneErr:
        !allService.empty(transacData.phone) &&
        !allService.empty(transacData.method) &&
        !allService.validateOperatorRegExp(
          paymentMethod ? paymentMethod.reg_exp : '',
          transacData.phone,
        )
          ? t('Incorrect_number') +
            ` (${paymentMethod ? paymentMethod.name : ''})`
          : '',
      amountErr:
        !allService.empty(transacData.amount) &&
        (transacData.amount < 100
          ? `${t('The_minimum_amount_is')} ${allService.numberWithCommas(
              100,
            )} Fcfa`
          : '' || transacData.transacAmount > 10000000000
          ? `${t('The_maximum_amount_is')} ${allService.numberWithCommas(
              10000000000,
            )} Fcfa`
          : ''),
    });
  }, [transacData]);

  useEffect(() => {
    if (downloadPopup) {
      $('.modal-download').fadeIn('fast');
    } else {
      $('.modal-download').fadeOut('fast');
    }
  }, [downloadPopup]);

  const renderPageError = () => (
    <div
      className="row col-12 col-lg-7 col-xl-6 m-auto p-0"
      style={{ zIndex: '1' }}
    >
      <div className="col col-12 p-0">
        <div
          className="content text-left col-12"
          style={{ background: 'inherit', zIndex: '2000' }}
        >
          <div className="container text-center mt-4">
            <div
              className="d-inline-block mb-3 empty-block p-4 rounded-circle"
              style={{ background: 'rgba(242, 243, 244, 1)' }}
            >
              <img
                src="/assets/img/icons8_error_cloud_125px.png"
                className="pr"
                style={{ left: '3px', width: '80px' }}
              />
            </div>
            <h5 className="mb-1">
              <strong>Oups! Une erreur est survenue</strong>
            </h5>
            <p>
              Une erreur est survenue lors de la récupération des données de
              transactions. Veuillez svp <strong>actualiser</strong> la page
              pour réessayer.
            </p>
            <div className="row col-12 col-lg-7 m-auto p-0">
              <div className="col col-12 col-md-6 m-auto">
                <button
                  onClick={() => {
                    window.location.reload();
                  }}
                  className="btn btn-primary mt-2 mb-2 app-btn w-100"
                  style={{
                    boxShadow: 'none',
                    borderRadius: 'initial',
                    padding: '15px',
                  }}
                >
                  <i className="icon-refresh mr-2"></i>
                  <span>
                    Actualiser
                    <br />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderExpiredLinkError = () => (
    <div
      className="row col-12 col-lg-7 col-xl-6 m-auto p-0"
      style={{ zIndex: '1' }}
    >
      <div className="col col-12 p-0">
        <div
          className="content text-left col-12"
          style={{ background: 'inherit', zIndex: '2000' }}
        >
          <div className="container text-center mt-4">
            <div
              className="d-inline-block mb-3 empty-block p-4 rounded-circle"
              style={{ background: 'rgba(242, 243, 244, 1)' }}
            >
              <img
                src="/assets/img/icons8_error_cloud_125px.png"
                className="pr"
                style={{ left: '3px', width: '80px' }}
              />
            </div>
            <h5 className="mb-1">
              <strong>
                Le lien de paiement n'est plus disponible ou a expiré
              </strong>
            </h5>
            {/* <p>
                Une erreur est survenue lors de la récupération des données
                de transactions. Veuillez svp <strong>actualiser</strong> la
                page pour réessayer.
              </p> */}
            <div className="flex justify-content-center mt-4">
              <Link
                to="/"
                className="btn btn-primary app-btn"
                style={{
                  boxShadow: 'none',
                  borderRadius: 'initial',
                  padding: '10px',
                }}
              >
                Retour à la page d'accueil
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderPaymentLinkForm = () => (
    <div
      className="row col-12 col-lg-7 col-xl-5 m-auto p-0"
      style={{ zIndex: 1 }}
    >
      <div className="w-100 p-0">
        <div
          className="content text-left col-12 mt-4"
          style={{ position: 'relative', zIndex: 2000 }}
        >
          <div className="container">
            <form className="mb-5">
              <h3 className="fw-800 title">{paymentLink.name}</h3>

              {paymentLink.desc && (
                <div
                  className="mt-2 fw-300"
                  style={{ height: '25px', fontSize: '0.9rem' }}
                >
                  {paymentLink.desc}
                </div>
              )}

              <div className="mb-4 mt-5">
                <div className="mb-4 mt-5">
                  <h6
                    className="text-left"
                    style={{
                      fontWeight: 300,
                      fontSize: '0.9rem',
                      lineHeight: 1,
                    }}
                  >
                    {t('payer_name')}
                  </h6>
                  <input
                    value={transacData.name}
                    onChange={(e) => handleChangePayerName(e)}
                    className="form-control"
                    type="text"
                  />
                </div>

                {/* Montant a verser */}
                {paymentLink.can_modify_amount === 1 && (
                  <div className="mb-4 mt-5">
                    <h6
                      className="text-left"
                      style={{
                        fontWeight: 300,
                        fontSize: '0.9rem',
                        lineHeight: 1,
                      }}
                    >
                      {t('Amount_to_be_payed')}
                    </h6>
                    <input
                      value={transacData.amount}
                      onChange={(e) => handleChangeTransacAmount(e)}
                      className="form-control"
                      type="number"
                    />
                    {!allService.empty(error.amountErr) && (
                      <span className="err">{error.amountErr}</span>
                    )}
                  </div>
                )}

                {/* Mode payment & numero a crediter */}
                <div className="mb-4">
                  <h6
                    className="mb-0"
                    style={{
                      fontWeight: 300,
                      fontSize: '0.9rem',
                      lineHeight: 1,
                    }}
                  >
                    {t('payment_mode')}
                  </h6>
                  <span
                    className="font-weight-light"
                    style={{ fontSize: '0.8em' }}
                  >
                    {t('payment_is_secured_and_without_charges')}
                  </span>

                  <div className="mt-2 mb-2">
                    <div
                      className="d-inline-block va-t open-list cursor"
                      style={{
                        backgroundColor: 'var(--input-background)',
                        paddingRight: '5px',
                        width: '77px',
                      }}
                    >
                      <div
                        className="d-inline-block"
                        style={{
                          width: '55px',
                          height: '55px',
                          padding: '5px',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                          }}
                        >
                          <img
                            className="img-fluid open-list op-selected d-inline-block rounded"
                            src={paymentMethod.logo}
                            style={{
                              width: '25px',
                              objectFit: 'contain',
                            }}
                          />
                        </div>
                      </div>
                      <i
                        className="icon-arrow-down fl-r fw-600"
                        style={{
                          fontSize: '0.800em',
                          position: 'relative',
                          top: '23px',
                        }}
                      ></i>
                    </div>

                    <div
                      className="drop-lang option-list"
                      style={{ width: '255px', marginTop: '10px' }}
                    >
                      <h6 style={{ fontSize: '0.865em' }}>
                        {t('choice_of_Operator')}
                      </h6>

                      {paymentMethods.map((mode) => {
                        return (
                          <div
                            key={`payment-method-${mode.code}`}
                            role="button"
                            onClick={() => handleSelectPaymentMethod(mode)}
                            className={`choice ${
                              mode.code === transacData.method
                                ? 'choice-selected'
                                : ''
                            } mb-1 elipsis`}
                          >
                            <img
                              src={mode.logo}
                              className="mr-2"
                              style={{ width: '20px' }}
                            />
                            {mode.name}
                          </div>
                        );
                      })}
                    </div>

                    <input
                      value={transacData.phone}
                      onChange={(e) => handleChangepayerPhone(e)}
                      className="form-control form-with-logo d-inline-block"
                      type="number"
                      style={{
                        width: 'Calc(100% - 77px)',
                        border: 'none',
                      }}
                      placeholder={`Numéro ${paymentMethod.name}`}
                    />
                  </div>
                  {!allService.empty(error.phoneErr) && (
                    <span className="err">{error.phoneErr}</span>
                  )}
                </div>

                <div
                  className="mb-2 fw-300"
                  style={{ height: '25px', fontSize: '0.9rem' }}
                >
                  <span className="fl-l fw-300">
                    {t('Charges_and_taxes')} :&nbsp;
                  </span>
                  <span className="fl-r">0 FCFA</span>
                </div>

                <div style={{ height: '25px' }}>
                  <h5 className="fl-l fw-700 title1">
                    {t('Total_to_be_paid')}
                  </h5>
                  <h5 className="fl-r fw-700 title1">
                    {transacData.amount
                      ? allService.numberWithCommas(transacData.amount)
                      : 0}{' '}
                    FCFA
                  </h5>
                </div>
              </div>

              <button
                disabled={isDisable}
                onClick={saveTransacData}
                className="btn btn-primary mt-3 mb-3 app-btn"
                type="button"
                style={{
                  width: '100%',
                  textTransform: 'uppercase',
                  boxShadow: 'none',
                  borderRadius: 'initial',
                  padding: '15px',
                }}
              >
                <i className="icon-wallet" />
                &nbsp;{' '}
                <span>
                  {t('Payment_Link_Button')}
                  <br />
                </span>
              </button>

              {!allService.empty(error.transacErr) && (
                <span className="err">{error.transacErr}</span>
              )}
            </form>

            <span
              className="fw-100 second-txt-color mt-4"
              style={{
                color: '#A6ACAF',
                fontWeight: 100,
                fontSize: '0.865em',
              }}
            >
              <i className="fa fa-copyright fw-100" />
              &nbsp;<span style={{ fontSize: '13.5px' }}>2022</span>
              &nbsp;
              <strong>Glotelho Pay&nbsp;</strong>
              <span
                className="lang fw-100 second-txt-color"
                keyword="all-rights-reserved"
              >
                {t('All_rights_reserved')}
              </span>
              .
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div
        className="w-100"
        style={{ height: 'auto', position: 'fixed', zIndex: 2000 }}
      >
        <div
          className="text-center elipsis pl-2 pr-2"
          style={{ background: '#C69E44', color: '#fff' }}
        >
          <span className="ads-txt">
            <span>
              <strong>No 1</strong>
            </span>
            <span className="font-weight-light">
              &nbsp;{t('Number_refill')}
            </span>
          </span>
        </div>

        <div
          style={{
            height: '70px',
            background: '#000a2b',
            color: '#fff',
            padding: '0 20px',
          }}
        >
          <div className="fl-l logo" style={{ position: 'relative' }}>
            <img className="img-fluid" src="/assets/img/glo-pay.png" />
          </div>

          <div
            className="fl-r cursor"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              data-toggle="dropdown"
              className="btn btn-primary option rounded-circle"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
            >
              <i className="material-icons">person</i>
            </a>

            <div
              className="d-none d-md-inline-block text-left"
              style={{
                marginLeft: '6px',
                paddingRight: '10px',
                verticalAlign: 'top',
                position: 'relative',
                top: '-2px',
              }}
              data-toggle="dropdown"
            >
              {!allService.empty(user) && !allService.empty(user.name) && (
                <div>
                  <h6
                    className="fw-400 mb-0 d-inline-block mr-2"
                    style={{ fontSize: '0.965em' }}
                  >
                    {user.name.split(' ')[0]}&nbsp;
                    <strong>
                      {user.name.split('').length > 1
                        ? user.name.split(' ')[1]
                        : ''}
                    </strong>
                  </h6>
                  <i
                    className="icon-arrow-down cursor"
                    style={{ fontSize: '0.835em', position: 'relative' }}
                  ></i>
                  <span
                    className="d-block pr"
                    style={{ fontSize: '0.765em', top: '-7px' }}
                  >
                    {allService.chunk(user.telephone, 3, ' ')}
                  </span>
                </div>
              )}
            </div>

            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                minWidth: '190px',
                fontSize: '1.26em',
                marginTop: '5px',
                marginRight: '18px',
              }}
            >
              {!allService.empty(user) && !allService.empty(user.name) && (
                <h6
                  className="fw-400 pr mb-0 d-md-none"
                  style={{ left: '15px', fontSize: '0.965em' }}
                >
                  {user.name.split(' ')[0]}
                  <strong>
                    {user.name.split('').length > 1
                      ? user.name.split(' ')[1]
                      : ''}
                  </strong>
                </h6>
              )}
              {!allService.empty(user) && !allService.empty(user.telephone) && (
                <span
                  className="d-block pr d-md-none"
                  style={{ fontSize: '0.665em', top: '-4px', left: '15px' }}
                >
                  {allService.chunk(user.telephone, 3, ' ')}
                </span>
              )}

              {!isAuthenticated && (
                <a onClick={() => navigation('/login')}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '2.9px', fontSize: '1.4em' }}
                  >
                    lock_open
                  </i>
                  &nbsp;
                  <span className="lang" keyword="my-account">
                    {t('login')}
                  </span>
                </a>
              )}

              {/* <a onClick={() => setShowTransaction(true)} className="translate">
                <i
                  className="material-icons pr menu-i mr-1"
                  style={{ top: '2.8px', fontSize: '1.2em' }}
                >
                  featured_play_list
                </i>
                &nbsp;
                <span className="lang" keyword="my-account">
                  {t('My_transactions')}
                </span>
              </a> */}

              {/* <a onClick={() => handleToggleFaq(true)} className="d-sm-none">
                <i
                  className="material-icons pr menu-i mr-1"
                  style={{ top: '2.8px', fontSize: '1.3em' }}
                >
                  help
                </i>
                &nbsp;
                <span className="lang" keyword="my-account">
                  FAQ
                </span>
              </a> */}

              {isAuthenticated && (
                <a onClick={() => disconnect()}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '3.9px', fontSize: '1.4em', padding: '1px' }}
                  >
                    power_settings_new
                  </i>
                  &nbsp;
                  <span className="lang" keyword="disconnect">
                    {t('Disconnect')}
                  </span>
                </a>
              )}
            </div>
          </div>

          <div
            onClick={() => showDownloadPopup(!downloadPopup)}
            className="fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              className="btn btn-primary option rounded-circle faq"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              title="Download"
            >
              <i className="material-icons">file_download</i>
            </a>
          </div>

          {/* <div
            onClick={() => handleToggleFaq()}
            className="fl-r mr-2 d-none d-sm-block"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              className="btn btn-primary option rounded-circle faq"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              title="FAQ"
            >
              <i className="material-icons">help</i>
            </a>
          </div> */}

          <div
            className="d-none d-xs-block fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <div
              style={{
                marginRight: '5px',
                display: 'inline-block',
                verticalAlign: 'middle',
              }}
            >
              <span className="lang" keyword="fr">
                {lang}
              </span>
            </div>
            <button
              className="btn btn-primary option rounded-circle"
              type="button"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              data-toggle="dropdown"
              title="Langue"
            >
              <i className="material-icons">language</i>
            </button>
            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                marginRight: '16px',
                marginTop: '5px',
                fontSize: '1.26em',
              }}
            >
              <a
                onClick={() => changeLanguageHandler('Fr')}
                id="fr"
                className="translate"
                data-reload
              >
                <img
                  src="/assets/img/france_96px.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;
                <span
                  className="lang"
                  keyword="french"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('french-lang')}
                </span>
                <br />
              </a>
              <a
                onClick={() => changeLanguageHandler('En')}
                id="en"
                className="translate"
              >
                <img
                  src="/assets/img/great_britain_96px-1.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;
                <span
                  className="lang"
                  keyword="english"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('english-lang')}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div style={{ paddingTop: '95px' }}>
        {userLoader && <UserLoader />}

        {pageErr && renderPageError()}

        {!userLoader &&
          !pageErr &&
          paymentLink &&
          paymentLink.status === 'PENDING' &&
          renderPaymentLinkForm()}

        {!userLoader &&
          !pageErr &&
          paymentLink &&
          paymentLink.status !== 'PENDING' &&
          renderExpiredLinkError()}

        {/**Modal to add or edit user*/}
        <Toaster toastOptions={{ position: 'bottom-center' }} />

        {showNewTransaction && (
          <NewTransaction
            showNewTransaction={showNewTransaction}
            setShowNewTransaction={setShowNewTransaction}
            paymentMethod={paymentMethod}
            transacData={{
              transacAmount: transacData.amount,
              paymentMethod: transacData.method,
              paymentMethodImg: paymentMethod.logo,
              payerPhone: transacData.phone,
            }}
            avortTransac={avortTransac}
          />
        )}

        <div className="modal modal-download" style={{ paddingTop: '100px' }}>
          <div
            id="modal-download"
            className="modal-content"
            style={{ overflow: 'auto', width: '45%' }}
          >
            <div>
              <i
                id="close-user-edit"
                className="icon ion-android-close close"
                onClick={() => showDownloadPopup(!downloadPopup)}
                style={{
                  color: 'inherit',
                  float: 'right',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  position: 'relative',
                  top: '0px',
                  left: '20px',
                }}
              ></i>
            </div>
            <div className="display text-left" style={{ display: 'block' }}>
              <div
                className="mt-2 text-center"
                style={{ border: 'none', padding: '0', fontSize: '1.4em' }}
              >
                <div className="row">
                  <div className="col">
                    <h4 className="fw-900 text-uppercase title1">
                      {t('download_header')}
                    </h4>
                  </div>
                </div>
                <span className="d-block mb-3" style={{ fontSize: '0.7em' }}>
                  {t('download_msg')}
                </span>
                <div className="col col-12 col-lg-8 m-auto">
                  <div className="row">
                    <div className="col p-0 pr-1">
                      <a
                        href="https://play.google.com/store/apps/details?id=cm.glotelho.glotelho_pay"
                        target="_blank"
                      >
                        <img
                          className="img-fluid"
                          src="/assets/img/google.png"
                        />
                      </a>
                    </div>
                    <div className="col p-0 pl-1">
                      <a
                        href="https://apps.apple.com/be/app/glotelho-pay/id1660530553"
                        target="_blank"
                      >
                        <img
                          className="img-fluid"
                          src="/assets/img/apple.png"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {transacSuccessMsg && (
          <div
            className="modal modal-transac-done display"
            style={{ display: `${transacSuccessMsg ? 'block' : 'none'}` }}
          >
            <div
              className="modal-content col-11 col-xl-4 col-lg-5 col-md-8"
              style={{
                padding: '0',
                position: 'relative',
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            >
              <div className="container text-center">
                <div
                  className="col"
                  style={{ padding: '40px 25px', paddingTop: '25px' }}
                >
                  <div>
                    <img
                      src="/assets/img/check-circle.gif"
                      className="img-fluid"
                      style={{ width: '100px' }}
                    />
                    <div className="mt-2">
                      <h5>
                        <strong>{t('Payment_done')} !</strong>
                      </h5>

                      {/* <span
                        className="d-block mb-3"
                        style={{ fontSize: '15px' }}
                      >
                        {t('Do_not_lose')} {t('history_of_your_transactions')}{' '}
                        <strong>{t('log_in')}</strong>{' '}
                        {t('To_have_on_all_devices')}
                      </span> */}
                    </div>

                    {/* <div>
                      <a
                        onClick={() => navigation('/login')}
                        className="btn btn-primary app-btn mb-3"
                        role="button"
                        href="#"
                        style={{ borderRadius: 'initial', padding: '15px' }}
                      >
                        {t('login')}
                      </a>
                    </div>
                    <p
                      className="mb-0 cursor close-modal-basket btn-close-form"
                      style={{ textDecoration: 'underline' }}
                    >
                      {t('Later')}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
